<template>
  <add-clients-modal
    id="AddClients"
    size="modal-lg"
    :show="show"
    :title="title"
    @closed="close"
  >
    <div>
      <base-search
        class="search-bar"
        :value="search"
        @input="$emit('on-search', $event)"
      />
    </div>

    <div
      class="add-clients__list"
      @scroll="onScroll"
    >
      <base-list
        #default="{item}"
        :items="filteredItems"
        :loading="loading"
        mode="loadMore"
        @reload="$emit('reload')"
      >
        <group-client-cell
          selectable
          hide-products
          hide-arrow
          :item="item"
          :checked="item.inGroup"
          @click="toggleMember(item, $event)"
        />
      </base-list>
    </div>

    <!--  FIXME  6/15/21 dlam:

        GroupDetailContainer dosent seem to be passing down

            :loading="nonMembersLoading"  (which is store.state.customers.isLoading)

        correctly (?)
    -->
    <template
      v-if="localItems.length > 0"
      #footer
    >
      <base-button
        hug
        @click="close"
      >
        Cancel
      </base-button>
      <base-button
        inverse
        hug
        :disabled="reactiveSet.length === 0"
        @click="addToGroup"
      >
        Add ({{ checkedItemCount }})
      </base-button>
    </template>
  </add-clients-modal>
</template>

<script>

import GroupClientCell from '../ClientsList/GroupClientCell';
import AddClientsModal from './AddClientsModal';

export default {
  name: 'GroupCreate',
  components: {
    GroupClientCell,
    AddClientsModal,
  },
  props: {
    groupName: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      required: true,
    },
    numMembers: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      search: '',
      localItems: [],
      modified: new Set(),
      reactiveSetTracker: 1,
      index: {},
    };
  },
  computed: {
    reactiveSet() {
      return this.reactiveSetTracker && Array.from(this.modified);
    },
    filteredItems() {
      return this.items;
    },
    title() {
      if (this.numMembers === 0) {
        return 'Add clients';
      } else {
        return 'Edit group';
      }
    },
    checkedItemCount() {
      return this.localItems.filter((x) => x.inGroup).length;
    },
  },
  watch: {
    items: {
      handler() {
        for (let i = 0; i < this.localItems.length; i++) {
          const item = this.localItems[i];
          if (item.inGroup) this.index[item.pk] = item;
        }
        const new_local = [];
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          if (this.index[item.pk]) item.inGroup = this.index[item.pk].inGroup;
          new_local.push(item);
        }
        // inGroup
        this.localItems = new_local;
      },
      immediate: true,
      deep: true,
    },

  },
  methods: {
    close() {
      this.show = false;
      this.search = '';
      this.$emit('modal-closed');
      this.localItems = [];
      this.index = {};
    },
    open() {
      this.show = true;
    },
    createGroup() {
      this.show = false;
    },
    addToGroup() {
      const add_group_members = [];
      const remove_group_members = [];
      this.localItems.filter((item) => this.modified.has(item.pk)).forEach((item) => {
        if (item.inGroup) {
          add_group_members.push(item.pk);
        } else {
          remove_group_members.push(item.pk);
        }
      });
      this.$emit('add-to-group', { add_group_members, remove_group_members });
      this.localItems = [];
      this.modified = new Set();
      this.reactiveSetTracker = 1;
      this.search = '';
      this.$emit('on-search', '');
      this.close();
    },
    toggleMember(item, isChecked) {
      const index = this.localItems.findIndex((customer) => customer.pk === item.pk);
      if (index !== -1) {
        this.localItems[index].inGroup = !this.localItems[index].inGroup;
      }
      if (this.modified.has(item.pk)) {
        this.modified.delete(item.pk);
      } else {
        this.modified.add(item.pk);
      }
      this.reactiveSetTracker += 1;
    },
    onScroll(evt) {
      if (evt.target.scrollTop + evt.target.clientHeight >= evt.target.scrollHeight) {
        // Bottom reached
        if (this.localItems.length <= this.count) {
          // Still elements to retrieve
          this.$emit('reached-bottom');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  margin-left: auto;
  min-width: 219px;
  height: 36px;

  &::v-deep input {
    font-size: 0.75rem;
  }
}
.add-clients{
  &__list {
    min-height: 50px;
    max-height: 50vh;
    overflow: auto;
    margin-top: 16px;
  }
  &__base-heading{
    letter-spacing: -0.016px;
    font-weight: 600;
    margin-bottom: 0;
    font-family: $font-family-timepos-headline;
  }
}

.add-button {
  margin: 0;
  background: $dark-black;
  color: white;
  width: 160px;
  height: 40px;
  justify-content: center;
  font-family: $font-family-sans-serif-medium;
}
.cancel-button {
  font-family: $font-family-sans-serif-medium;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 5px 15px;
}
.client-cell-external{
  &_name{
    color: red;
  }
}
</style>
